import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { InputField } from 'components';
import { Utils } from 'frilans-finans';

export class Invoicing extends React.Component {
  static propTypes = {
    invoice: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    setSendToEmail: PropTypes.func.isRequired,
    setSendToEmailSecondary: PropTypes.func.isRequired,
    setSendToEmailBool: PropTypes.func.isRequired,
    setCompanyPhone: PropTypes.func.isRequired,
    setEinvoiceAddress: PropTypes.func.isRequired,
    setPoNumber: PropTypes.func.isRequired,
    setMessageType: PropTypes.func.isRequired,
    translationPrefix: PropTypes.string.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      formValues: {
        email: {},
        emailSecondary: {},
        phone: {},
        einvoice: {},
        poNumber: {}
      },
      showErrorWithoutBlur: false,
      radioRefs: {}
    };

    this.messageTypes = {
      email: 'email',
      sms: 'sms',
      mail: 'mail',
      einvoice: 'e-invoice'
    };
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.invoice.sendToEmail !== this.props.invoice.sendToEmail) {
      this.handleChange('email', { value: nextProps.invoice.sendToEmail });
    }

    if (nextProps.invoice.sendToEmailSecondary !== this.props.invoice.sendToEmailSecondary) {
      this.handleChange('emailSecondary', { value: nextProps.invoice.sendToEmailSecondary });
    }

    if (nextProps.invoice.companyPhone !== this.props.invoice.companyPhone) {
      this.handleChange('phone', { value: nextProps.invoice.companyPhone });
    }

    if (nextProps.invoice.einvoiceAddress !== this.props.invoice.einvoiceAddress) {
      this.handleChange('einvoice', { value: nextProps.invoice.einvoiceAddress });
    }

    if (nextProps.invoice.poNumber !== this.props.invoice.poNumber) {
      this.handleChange('poNumber', { value: nextProps.invoice.poNumber });
    }

    if (nextProps.invoice.submitted && !this.state.showErrorWithoutBlur) {
      this.setState({showErrorWithoutBlur: true});
    }
  }

  handleChange = (name, values) => {
    let tempFormValues = this.state.formValues;

    Object.assign(tempFormValues[name], values);
    this.setState({formValues: tempFormValues}, () => {
      if (name === 'email') {
        this.props.setSendToEmail(values.value);
      }
      if (name === 'emailSecondary') {
        this.props.setSendToEmailSecondary(values.value);
      }
      if (name === 'phone') {
        this.props.setCompanyPhone(values.value);
      }
      if (name === 'einvoice') {
        this.props.setEinvoiceAddress(values.value);
      }
      if (name === 'poNumber') {
        this.props.setPoNumber(values.value);
      }
    });
  }

  isChecked = (messageType) => messageType === this.props.invoice.messageType;

  handleSelectionChange = (event) => {
    this.props.setMessageType(event.target.value);
  };

  isCompany = () => {
    if (this.props.invoice.customerEntity) {
      return Utils.isVatNumber(this.props.invoice.customerEntity.vatNr);
    }
    return false;
  }

  renderEmailSection = () => {
    var radioRef = this.state.radioRefs.email;
    return (
      <div className='message-type-row' onClick={function () { radioRef.click(); }}>
        <div className='checkbox-container'>
          {this.renderRadioButton(this.messageTypes.email)}
        </div>

        {!this.isChecked(this.messageTypes.email) &&
          <div className="short-description"><Translate content="INVOICING_SEND_INVOICE_BY_EMAIL"/></div>
        }

        {this.isChecked(this.messageTypes.email) &&
          <div>
            <InputField type='email'
              name='email'
              value={this.state.formValues.email.value}
              placeholder={proxyCounterpart('INVOICING_SEND_INVOICE_BY_EMAIL_TO')}
              callback={this.handleChange}
              minLength={this.isChecked(this.messageTypes.email) ? '3' : '0'}
              required={this.isChecked(this.messageTypes.email) ? 'true' : 'false'}
              errorMessage={proxyCounterpart('EMAIL_ERROR')}
              classes={'invoicing-contact-fields'}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />
            <InputField type='email'
              name='emailSecondary'
              value={this.state.formValues.emailSecondary.value}
              placeholder={proxyCounterpart('INVOICING_SEND_INVOICE_BY_EMAIL_TO_SECONDARY')}
              callback={this.handleChange}
              minLength={'0'}
              required={'false'}
              classes={'invoicing-contact-fields'}
              errorMessage={proxyCounterpart('EMAIL_ERROR')}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />
          </div>
        }
      </div>
    );
  }

  renderSwishSection = () => {
    const radioRef = this.state.radioRefs.sms;
    const disabled = this.isCompany();
    const disabledClass = disabled ? 'disabled' : '';

    return (
      <div className={'message-type-row ' + disabledClass} onClick={function () { radioRef.click(); }}>
        <div className='checkbox-container'>
          {this.renderRadioButton(this.messageTypes.sms, disabled)}
        </div>

        {!this.isChecked(this.messageTypes.sms) && !disabled &&
          <div className="short-description">
            <Translate content="INVOICING_SEND_INVOICE_BY_SMS"/>
            <img src={require('images/logos/swish_horizontal.svg')} width="50px"/>
          </div>
        }

        {!this.isChecked(this.messageTypes.sms) && disabled &&
          <div className="short-description"><Translate content="INVOICING_CANT_SEND_INVOICE_BY_SMS"/></div>
        }

        {this.isChecked(this.messageTypes.sms) &&
          <div className='short-description'>
            <div>
              <InputField type='text'
                name='phone'
                validationType='phoneNumberSwedish'
                value={this.state.formValues.phone.value}
                placeholder={proxyCounterpart('INVOICING_SEND_INVOICE_BY_SMS_TO')}
                callback={this.handleChange}
                minLength='3'
                required={this.isChecked(this.messageTypes.sms) ? 'true' : 'false'}
                classes={'invoicing-contact-fields'}
                errorMessage={proxyCounterpart('VALIDATION_COMPANY_PHONE_PHONENUMBER_SE_FALSE')}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur}
              />
              <div
                className="message-type-description"
                dangerouslySetInnerHTML={{__html: proxyCounterpart('INVOICING_MESSAGE_TYPE_SMS')}}
              />
            </div>
            <img src={require('images/logos/swish_horizontal.svg')} width="50px"/>
          </div>
        }
      </div>
    );
  }

  renderMailSection = () => {
    var radioRef = this.state.radioRefs.mail;
    return (
      <div className='message-type-row' onClick={function () { radioRef.click(); }}>
        <div className='checkbox-container'>
          {this.renderRadioButton(this.messageTypes.mail)}
        </div>

        {!this.isChecked(this.messageTypes.mail) &&
          <div className="short-description"><Translate content="INVOICING_SEND_INVOICE_BY_MAIL"/></div>
        }

        {this.isChecked(this.messageTypes.mail) &&
          <div className='text-area-container'>
            <div className='title'><Translate content='INVOICING_SEND_INVOICE_BY_MAIL_TO'/></div>
            <div className='invoicing-address'>
              {this.props.invoice.customerEntity &&
                this.renderAddress(this.props.invoice.customerEntity)
              }
              {!this.props.invoice.customerEntity &&
                <div>
                  <p className='error-msg'><Translate content='CHOOSE_CUSTOMER'/></p>
                </div>
              }
            </div>
          </div>
        }
      </div>
    );
  }

  renderEinvoiceSection = () => {
    const radioRef = this.state.radioRefs['e-invoice'];
    return (
      <div className='message-type-row' onClick={function () { radioRef.click(); }}>
        <div className='checkbox-container'>
          {this.renderRadioButton(this.messageTypes.einvoice)}
        </div>

        {!this.isChecked(this.messageTypes.einvoice) &&
          <div className="short-description"><Translate content="INVOICING_SEND_INVOICE_BY_E_INVOICE"/></div>
        }
        {this.isChecked(this.messageTypes.einvoice) &&
          <div>
            <InputField type='text'
              name='einvoice'
              value={this.state.formValues.einvoice.value}
              validationType="einvoice"
              placeholder={proxyCounterpart('INVOICING_SEND_INVOICE_BY_E_INVOICE_TO')}
              callback={this.handleChange}
              minLength={this.isChecked(this.messageTypes.einvoice) ? '10' : '0'}
              required={this.isChecked(this.messageTypes.einvoice) ? 'true' : 'false'}
              classes={'invoicing-contact-fields'}
              errorMessage={
                Utils.containsAtSign(this.state.formValues.einvoice.value)
                ? proxyCounterpart('NO_EMAIL_ERROR')
                : proxyCounterpart('EINVOICE_ERROR')
              }
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />
            <InputField type='text'
              name='poNumber'
              value={this.state.formValues.poNumber.value}
              placeholder={proxyCounterpart('PO_NUMBER')}
              callback={this.handleChange}
              maxLength={this.isChecked(this.messageTypes.einvoice) ? '30' : '0'}
              required={'false'}
              classes={'invoicing-contact-fields extra-message-type-input'}
              errorMessage={proxyCounterpart('PO_NUMBER_ERROR')}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
            />
            <div
              className="message-type-description"
              dangerouslySetInnerHTML={{__html: proxyCounterpart('INVOICING_MESSAGE_TYPE_EINVOICE')}}
            />
          </div>
        }
      </div>
    );
  }

  renderRadioButton = (messageType, disabled) => {
    return (
      <div className='radio-btn-wrapper'>
        <input
          id={messageType}
          type='radio'
          name={messageType}
          value={messageType}
          checked={this.isChecked(messageType)}
          onChange={this.handleSelectionChange}
          disabled={disabled}
          /*eslint-disable */
          ref={input => { this.state.radioRefs[messageType] = input; }}
          /*eslint-enable */
        />
        <label className='radio-btn' htmlFor={messageType}><span></span></label>
      </div>
    );
  }

  renderAddress = (customer) => {
    return (
      <div>
        <p className='name'>
          {customer.name}
        </p>
        {customer.address &&
          <div className='address'>
            <p>{customer.address.co}</p>
            <p>{customer.address.street}</p>
            <p>{customer.address.zip} {customer.address.city} {customer.address.country}</p>
          </div>
        }
      </div>
    );
  }

  render () {
    return (
      <div className='invoicing section-padding'>
        <div>
          <h3 className='form-header'><span>4</span> <Translate content='INVOICING'/></h3>
          <p><Translate content={this.props.translationPrefix + 'INVOICING_TEXT'}/></p>
        </div>
        <div className='white-box left'>
          {this.renderEmailSection()}
          {this.renderMailSection()}
          {this.renderSwishSection()}
          {this.renderEinvoiceSection()}
        </div>
      </div>
    );
  }
}

export default Invoicing;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/invoicing/invoicing.js
 **/